/**
 * Message Templates Constants
 * Predefined categories, channels, variables, and validation rules
 */

// Template Categories
export const TEMPLATE_CATEGORIES = [
  { value: 'follow_up', label: 'Follow-up' },
  { value: 'appointment', label: 'Appointment' },
  { value: 'welcome', label: 'Welcome' },
  { value: 'updates', label: 'Updates' },
  { value: 'closing', label: 'Closing' },
  { value: 'no_response', label: 'No Response' },
  { value: 'general', label: 'General' },
] as const;

export type TemplateCategory = (typeof TEMPLATE_CATEGORIES)[number]['value'];

// Template Channels
export const TEMPLATE_CHANNELS = [
  { value: 'sms', label: 'SMS' },
  { value: 'email', label: 'Email' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'facebook', label: 'Facebook' },
  { value: 'instagram', label: 'Instagram' },
] as const;

export type TemplateChannel = (typeof TEMPLATE_CHANNELS)[number]['value'];

// Template Variables
export const TEMPLATE_VARIABLES = {
  lead: [
    { key: 'lead_first_name', label: 'First Name', description: "Lead's first name" },
    { key: 'lead_last_name', label: 'Last Name', description: "Lead's last name" },
    { key: 'email', label: 'Email', description: "Lead's email address" },
    { key: 'phone', label: 'Phone', description: "Lead's phone number" },
  ],
  property: [
    { key: 'property_address', label: 'Address', description: 'Property street address' },
    { key: 'property_city', label: 'City', description: 'Property city' },
    { key: 'property_price', label: 'Price', description: 'Listing price' },
    { key: 'property_id', label: 'ID', description: 'Property ID' },
    { key: 'property_link', label: 'Link', description: 'Link to property listing' },
  ],
  agent: [
    { key: 'agent_name', label: 'Agent Name', description: "Agent's name" },
    { key: 'business_name', label: 'Business Name', description: 'Business/brokerage name' },
    { key: 'agent_phone', label: 'Agent Phone', description: "Agent's phone number" },
  ],
} as const;

// Template Status
export const TEMPLATE_STATUSES = [
  { value: 'draft', label: 'Draft' },
  { value: 'published', label: 'Published' },
] as const;

export type TemplateStatus = (typeof TEMPLATE_STATUSES)[number]['value'];

// Sorting Options
export const TEMPLATE_SORT_OPTIONS = [
  { value: 'most_used', label: 'Most Used' },
  { value: 'newest', label: 'Newest' },
  { value: 'alphabetical', label: 'Alphabetical' },
] as const;

export type TemplateSortOption = (typeof TEMPLATE_SORT_OPTIONS)[number]['value'];

// Tab Options
export const TEMPLATE_TABS = [
  { value: 'my_templates', label: 'My Templates' },
  { value: 'shared_with_me', label: 'Shared with Me' },
  { value: 'shared_by_me', label: 'Shared by Me' },
] as const;

export type TemplateTab = (typeof TEMPLATE_TABS)[number]['value'];

// Validation Constants
export const TEMPLATE_VALIDATION = {
  NAME_MIN_LENGTH: 1,
  NAME_MAX_LENGTH: 100,
  CONTENT_MIN_LENGTH: 1,
  CONTENT_MAX_LENGTH: 2000,
  MIN_CHANNELS: 1,
} as const;

// LocalStorage Keys
export const TEMPLATE_STORAGE_KEYS = {
  VIEW_PREFERENCE: 'templates-view-preference',
} as const;

// View Mode Types
export const TEMPLATE_VIEW_MODES = ['grid', 'table'] as const;
export type TemplateViewMode = (typeof TEMPLATE_VIEW_MODES)[number];
